module.exports = __webpack_public_path__ + "img/image185.181c5aaa.png";